'use client'

import dynamic from 'next/dynamic'

// Detailed ratings are optional; summary-only product pages never need this
// chart/widget bundle. Authored breakdowns retain their server-rendered HTML.
export const ReviewRatingBreakdownLazy = dynamic(() =>
  import('./review-rating-breakdown').then((module) => module.ReviewRatingBreakdown)
)
